import React, { useEffect, useState } from 'react';
import { executeLaravelAPI } from '../../Utils';

const DeveloperDetails = () => {
  const [developers, setDevelopers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let canceled = false;
    setLoading(true);
    setError(null);

    (async () => {
      try {
        // Use executeLaravelAPI which will build base URL, headers and add bwusercheck on localhost
        const response = await executeLaravelAPI('developers', { per_page: 35 }, 'GET');

        // Response shape: { data: { data: [...], meta: {...} } } (Laravel paginated)
        const data = Array.isArray(response?.data?.data)
          ? response.data.data
          : Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response)
          ? response
          : [];

        if (!canceled) {
          setDevelopers(data);
          console.log('Developers →', data);
          setLoading(false);
        }
      } catch (err) {
        if (!canceled) {
          console.error('Error fetching developers:', err);
          setError(err.message || 'Failed to fetch developers');
          setLoading(false);
        }
      }
    })();

    return () => {
      canceled = true;
    };
  }, []);

  return (
    <div className="developer-list card p-3">
      <h5 className="mb-3">Developers</h5>

      {loading && <div>Loading developers...</div>}
      {error && <div className="text-danger">Error: {error}</div>}

      {!loading && !error && (
        <>
          <table className="table table-hover table-bordered mb-0">
            <thead className="table-secondary">
              <tr>
                <td style={{ width: '60px' }}>No.</td>
                <td>Developer Name</td>
                <td style={{ width: '180px' }} className="text-end">
                  Total Completed Projects
                </td>
              </tr>
            </thead>

            <tbody>
              {developers.length === 0 ? (
                <tr>
                  <td colSpan={3} className="text-center py-3">
                    No developers found.
                  </td>
                </tr>
              ) : (
                developers.map((dev, index) => (
                  <tr key={dev.id ?? index}>
                    <td style={{ verticalAlign: 'middle' }}>{index + 1}</td>
                    <td style={{ verticalAlign: 'middle' }}>{dev.name ?? '—'}</td>
                    <td style={{ verticalAlign: 'middle' }} className="text-end">
                      {dev.total_completed_projects ?? 0}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <div className="mt-2 text-muted small">
            Showing {developers.length} developer{developers.length !== 1 ? 's' : ''}.
          </div>
        </>
      )}
    </div>
  );
};

export default DeveloperDetails;
